/** Match the backend's deliberately narrow apparent-age policy parser. */
export function parseApparentAge(value: string | null | undefined): number | null {
  if (!value) return null;
  const match = value.trim().match(/^([0-9]{1,3})(?:\s*(?:years? old|yo))?$/i);
  if (!match) return null;
  const age = Number(match[1]);
  return Number.isFinite(age) ? age : null;
}

export function isMinorApparentAge(value: string | null | undefined): boolean {
  const age = parseApparentAge(value);
  return age !== null && age < 18;
}
